'use client';

import React, { useState } from 'react';

import type { CodeBlock } from '@/payload-types';

type Props = {
  code: CodeBlock['code'];
};

import { useLocale } from '@/contexts/LocaleContext';
import { getDictionary } from '@/utils/getDictionary';

import styles from './block.module.scss';

export const CopyCodeButton: React.FC<Props> = (props) => {
  const { code } = props;

  const locale = useLocale();
  const t = getDictionary(locale);
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code as string);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  if (!code) {
    return null;
  }

  return (
    <button className={styles.copyCode} onClick={copyToClipboard}>
      {copied ? `${t('copied')}!` : t('copy')}
    </button>
  );
};
